import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  PaymentCardsAction,
  StoreAction,
  PaymentMethodAction,
  CartAction,
} from "store/actions";
import C from "Constants";

export const DineInPaymentOptions = {
    "Complete Payment Now": {
      id: C.PAY_NOW,
      title: "Complete Payment Now",
      description: "Pay now and get your order immediately",
    },
    "Dine First, Pay Later": {
      id: C.PAY_LATER,
      title: "Dine First, Pay Later",
      description: "Pay later and get your order after the table is paid",
    },
  };
  

const usePaymentOptionSelection = ({ setSelectedPaymentOptions=()=>{} }={}) => {
  const dispatch = useDispatch();
  const { selectedStore } = useSelector((state) => state.store);
  const resetPaymentType = () => {
    dispatch(
      PaymentCardsAction.setstripeSelectedCard({
        cardInfo: {},
        isStoredCard: false,
      }),
    );
    dispatch(PaymentCardsAction.setstripePaymentCards([]));
    dispatch(StoreAction.setSelectedPaymentMethod(null));
    dispatch(PaymentMethodAction.setSelectedPaymentType(null));
  };

  const payLaterOption = useMemo(() => {
    return selectedStore?.dineInPaymentOptions?.find(
      (dIPO) => dIPO?.paymentType === C.PAY_LATER
    );
  }, [selectedStore?.dineInPaymentOptions]);

  const handleSelectPayLater = () => {
    if(payLaterOption){
        dispatch(StoreAction.setSelectedPaymentMethod(payLaterOption));
        dispatch(PaymentMethodAction.setSelectedPaymentType(C.PAY_LATER));
        dispatch(PaymentCardsAction.resetSelectedCards());
        dispatch(CartAction.clearSplit());
  }
  };

  const handleOptionChange = (option) => {
    if (option?.id === C.PAY_LATER) {
      resetPaymentType();
      handleSelectPayLater();
    }
    setSelectedPaymentOptions(option);
    dispatch(
      CartAction.setDineInPaymentOptions({
        paymentOptions: option,
      }),
    );
  };
  return {
    resetPaymentType,
    handleSelectPayLater,
    handleOptionChange,
  };
};

export default usePaymentOptionSelection;
